// extracted by mini-css-extract-plugin
export default {"copyScheduleModalFormItem":"styles_copy-schedule-modal-form-item__cOSxQ"};